import axios from 'axios';
import config from '../environment/config';
import { authHeader } from './auth.header';
// import { authHeader } from 'services/auth.header'; 
const API_URL = config.API_URL;


export class UserDto {
    constructor(name,email,phone,organizationName,dob,gender,country,state,city,permanentAddress,currentAddress,pincode) {
        this.name = name;
        this.email = email;
        this.phone = phone;
        this.organizationName = organizationName;
        this.dob = dob;
        this.gender = gender;
        this.country = country;
        this.state = state;
        this.city = city;
        this.permanentAddress = permanentAddress;
        this.currentAddress = currentAddress;
        this.pincode = pincode;
      }
}



export const submitPersonalInfoUpdate = async (userInfoDto) => {
    try {
      const response = await axios.put(
        `${API_URL}updateUser`,
        userInfoDto,
       { headers: authHeader() }
      );
      return response.data;
    } catch (error) {
      console.error('Error occurred in submitPersonalInfoUpdate:', error);
      throw error;
    }
  };


  
 // Method to fetch user details using the logged-in user's information
 export const getUserInfo = async () => {
  const user = JSON.parse(localStorage.getItem('user')); 
  const username = user?.username; 

  if (!username) {
    throw new Error('No user found');
  }


  try {
    const response = await axios.post(
      `${API_URL}get-user-details`,
      {}, // Empty body
      { headers: { 'Content-Type': 'application/json', ...authHeader() } }
    );

    const userDetails = response.data;

    return userDetails; // Return structured object

  } catch (error) {
    console.error(' Error occurred in getUserInfo:', error);
    throw error;
  }
};



export class ProfessionalInfoDto {
  constructor(professionalInfoId,loginId,title,employerType,employer,totalExp,currentTechnology) {
      this.professionalInfoId = professionalInfoId;
      this.loginId = loginId;
      this.title = title;
      this.employerType = employerType;
      this.employer = employer;
      this.totalExp = totalExp;
      this.currentTechnology = currentTechnology;
    }
}

export const submitProfessionalInfoAdd = async (professionalInfoDto) => {
  try {
    const response = await axios.post(
      `${API_URL}professional-info`,
      professionalInfoDto,
     { headers: authHeader() }
    );
    return response.data;
  } catch (error) {
    console.error('Error occurred in submitProfessionalInfoUpdate:', error);
    throw error;
  }
};


export const submitProfessionalInfoUpdate = async (professionalInfoDto) => {
  try {
    const response = await axios.put(
      `${API_URL}professional-info`,
      professionalInfoDto,
     { headers: authHeader() }
    );
    return response.data;
  } catch (error) {
    console.error('Error occurred in submitProfessionalInfoUpdate:', error);
    throw error;
  }
};

export const getProfessionalInfoById = async (id) => {
  try {
    const response = await axios.get(`${API_URL}professional-info/${id}`, {
      headers: authHeader(),
    });
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      console.warn("Professional Info not found, returning empty.");
      return null; // Return null so React can handle it
    }
    throw error;
  }
};



export class EducationalInfoDto {
  constructor(educationalInfoId,loginId,degree,fieldOfStudy,graduationMonth,graduationYear) {
      this.educationalInfoId = educationalInfoId;
      this.loginId = loginId;
      this.degree = degree;
      this.fieldOfStudy = fieldOfStudy;
      this.graduationMonth = graduationMonth;
      this.graduationYear = graduationYear;
    }
}

export const submitEducationalInfoAdd = async (educationalInfoDto) => {
  try {
    const response = await axios.post(
      `${API_URL}educational-info`,
      educationalInfoDto,
     { headers: authHeader() }
    );
    return response.data;
  } catch (error) {
    console.error('Error occurred in submitEducationalInfoAdd:', error);
    throw error;
  }
};




export const submitEducationalInfoUpdate = async (educationalInfoDto) => {
  try {
    const response = await axios.put(
      `${API_URL}educational-info`,
      educationalInfoDto,
     { headers: authHeader() }
    );
    return response.data;
  } catch (error) {
    console.error('Error occurred in submitEducationalInfoUpdate:', error);
    throw error;
  }
};


export const getEducationalInfoById = async (id) => {
  try {
    const response = await axios.get(`${API_URL}educational-info/${id}`, {
      headers: authHeader(),
    });
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      console.warn("Educational Info not found, returning empty.");
      return null; // Return null so React can handle it
    }
    throw error;
  }
};









  